import script from "./EditMdaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditMdaPage.vue?vue&type=script&setup=true&lang=js"

import "./EditMdaPage.vue?vue&type=style&index=0&id=f5648dae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5648dae"]])

export default __exports__